exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auction-meeting[data-v-6509ec5f] {\n  overflow: hidden;\n  position: relative;\n}\n.auction-meeting .title[data-v-6509ec5f] {\n  font-size: 16px;\n}\n.auction-meeting .title .l[data-v-6509ec5f] {\n  font-weight: 600;\n  line-height: 22px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.auction-meeting .title .r[data-v-6509ec5f] {\n  line-height: 16px;\n  height: 20px;\n  background: #FFFFFF;\n  border-radius: 10px;\n  border: 1px solid #fff;\n  padding: 2px 8px;\n  font-size: 12px;\n}\n", ""]);

// exports
